import {organizationColors} from "../../../chart/config";
import React from "react";
import './Legend.scss';

const Legend = ({data}: any) => {

    const color = (gmina: string) => {

        // @ts-ignore
        const backgroundColor = organizationColors[gmina];

        const style = {
            backgroundColor,
            width: '24px',
            height: '6px'
        }
        return <div style={style}/>
    }

    return <>
        <div className='legend'>
            <ul>
                {
                    data.filter((item: any) => item.key === 'organization')
                        .map((item: any) => (item.data.sort((a: string, b: string) => a.localeCompare(b)).map((gmina: string, i: number) => (
                                <li key={i}>
                                    {color(gmina)}
                                    <span>{gmina}</span>
                                </li>
                            ))
                        ))
                }
            </ul>

        </div>
    </>

}

export {Legend}